(function() {
    var OPEN_EVENT = 'subscription-minimum-info-popup:open';
    var CLOSE_EVENT = 'subscription-minimum-info-popup:close';

    function dispatchPopupEvent(eventName, detail) {
        window.dispatchEvent(new CustomEvent(eventName, {
            detail: detail || {}
        }));
    }

    window.AlphaFoodsTheme = window.AlphaFoodsTheme || {};
    window.AlphaFoodsTheme.subscriptionMinimumInfoPopup = {
        open: function(detail) {
            dispatchPopupEvent(OPEN_EVENT, detail);
        },
        close: function() {
            dispatchPopupEvent(CLOSE_EVENT);
        }
    };

    window.openSubscriptionMinimumInfoPopup = function(detail) {
        window.AlphaFoodsTheme.subscriptionMinimumInfoPopup.open(detail);
    };

    window.closeSubscriptionMinimumInfoPopup = function() {
        window.AlphaFoodsTheme.subscriptionMinimumInfoPopup.close();
    };
})();

(function() {
    var initialized = false;

    function toggleVideoMute(button) {
        var card = button.closest('.community-post__media-wrap');
        if (!card) {
            return;
        }

        var video = card.querySelector('video');
        if (!video) {
            return;
        }

        video.muted = !video.muted;
        button.classList.toggle('is-muted', video.muted);
        button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }

    function onDocumentClick(event) {
        var toggleButton = event.target.closest('[data-community-mute-toggle]');
        if (!toggleButton) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        toggleVideoMute(toggleButton);
    }

    function init() {
        if (initialized) {
            return;
        }

        initialized = true;
        document.addEventListener('click', onDocumentClick);
    }

    window.AlphaFoodsTheme = window.AlphaFoodsTheme || {};
    window.AlphaFoodsTheme.communitySection = {
        init: init
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
        init();
    }
})();

(function() {
    // Delegated mute toggle: a [data-mute-toggle] button mutes/unmutes the <video>
    // in its nearest [data-video-wrap]. Global so it serves every section that uses
    // that markup pair (landing-greens video slider + product Media + features).
    function toggleVideoMute(button) {
        var wrap = button.closest('[data-video-wrap]');
        if (!wrap) {
            return;
        }

        var video = wrap.querySelector('video');
        if (!video) {
            return;
        }

        video.muted = !video.muted;
        button.classList.toggle('is-muted', video.muted);
        button.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    }

    document.addEventListener('click', function(event) {
        var toggleButton = event.target.closest('[data-mute-toggle]');
        if (!toggleButton) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        toggleVideoMute(toggleButton);
    });
})();